/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignalRMsgScreenshotResponse } from '../../models/signal-r-msg-screenshot-response';

export interface HubsHubKioskSendScreenshotPost$Params {
  response?: SignalRMsgScreenshotResponse;
}

export function hubsHubKioskSendScreenshotPost(http: HttpClient, rootUrl: string, params?: HubsHubKioskSendScreenshotPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, hubsHubKioskSendScreenshotPost.PATH, 'post');
  if (params) {
    rb.query('response', params.response, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

hubsHubKioskSendScreenshotPost.PATH = '/hubs/HubKiosk/SendScreenshot';
